import React from 'react';
import PropTypes from 'prop-types';

export const AlertIcon = (({ width=48, height=48, color='#0083C6' }) => {
    return (
        <svg width={width} height={height} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M27.7698 10.6221C26.2081 8.08267 22.5171 8.08267 20.9554 10.6221L5.20186 36.2379C3.56284 38.903 5.48032 42.3333 8.60909 42.3333H40.1161C43.2449 42.3333 45.1623 38.903 43.5233 36.2379L27.7698 10.6221ZM23.1669 30.9736L22.6785 18.7895H25.9959L25.5075 30.9736H23.1669ZM24.3652 35.9917C23.8292 35.9917 23.4154 35.8352 23.1209 35.5229C22.8264 35.2069 22.6785 34.763 22.6785 34.1933C22.6785 33.6016 22.8204 33.1511 23.1096 32.8483C23.3988 32.5447 23.8153 32.3948 24.3652 32.3948C24.8991 32.3948 25.3096 32.5477 25.5988 32.8607C25.8913 33.1701 26.0379 33.614 26.0379 34.1933C26.0379 34.7513 25.888 35.1887 25.5962 35.5105C25.3024 35.8323 24.8938 35.9917 24.3652 35.9917Z" fill={color}/>
        </svg>
    );
});

AlertIcon.displayName = 'AlertIcon';
AlertIcon.propTypes = {
    width: PropTypes.number,
    height: PropTypes.number,
    color: PropTypes.string
};
